
// TODO 年终报告

export default [
  {
    path: '/annual-report/info',
    name: 'annualReport',
    component: () => import(/* webpackChunkName: "annualReport" */ '@/views/annual-report/info.vue')
  }
]
